var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "errorContainer",
    { attrs: { error: _vm.erreur, warning: _vm.warning } },
    [
      _vm.Dlvs
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "h1",
                  {
                    class: [
                      `${!_vm.$screen.sm ? "main-page-title" : ""}`,
                      { "is-pwa": _vm.$isPwa() },
                    ],
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.FormMSG(215, "User going to this accomodation")
                        ) +
                        "\n\t\t\t"
                    ),
                  ]
                ),
              ]),
              _c(
                "b-col",
                { attrs: { cols: "12", xl: "12" } },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide" } },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "card-border-blue-light form",
                          attrs: { "no-body": "" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "px-4 pt-3" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex justify-content-start",
                                      attrs: { sm: "12" },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn-transparent d-flex align-items-center",
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.back()
                                            },
                                          },
                                        },
                                        [
                                          _c(_vm.getLucideIcon("ArrowLeft"), {
                                            tag: "component",
                                            staticClass: "icon",
                                            attrs: {
                                              color: "rgba(6, 38, 62, 0.65)",
                                              size: 22,
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "title-back-bolder ml-1",
                                            },
                                            [_vm._v(_vm._s(this.backTo()))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "pt-3" },
                                [
                                  _c(
                                    "fieldset",
                                    {
                                      staticClass:
                                        "scheduler-border border-groove-blue-streak pt-0",
                                    },
                                    [
                                      _c(
                                        "legend",
                                        {
                                          staticClass:
                                            "scheduler-border text-color-blue-streak",
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(this.caption1)
                                          ),
                                          _c("strong", [
                                            _vm._v(_vm._s(this.caption31)),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                sm: "12",
                                                md: "6",
                                                lg: "6",
                                                xl: "6",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: _vm.FormMSG(
                                                      50,
                                                      "Booking document"
                                                    ),
                                                    "label-for":
                                                      "accConfirmationFileBrowse",
                                                  },
                                                },
                                                [
                                                  _c("b-form-file", {
                                                    ref: "pdfConfirmationFileId",
                                                    attrs: {
                                                      "browse-text":
                                                        _vm.FormMSG(
                                                          113,
                                                          "Browse"
                                                        ),
                                                      name: "test",
                                                      id: "accConfirmationFileBrowse",
                                                      accept:
                                                        _vm.supportedMimeTypes,
                                                      placeholder: _vm.FormMSG(
                                                        51,
                                                        "Choose a file or drop it here..."
                                                      ),
                                                      "drop-placeholder":
                                                        _vm.FormMSG(
                                                          52,
                                                          "Drop file here..."
                                                        ),
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.submitConfirmationFile,
                                                    },
                                                    model: {
                                                      value: _vm.pdfFile,
                                                      callback: function ($$v) {
                                                        _vm.pdfFile = $$v
                                                      },
                                                      expression: "pdfFile",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "d-flex justify-content-start align-items-end",
                                              staticStyle: {
                                                "margin-bottom": "-3px",
                                              },
                                              attrs: {
                                                sm: `${
                                                  _vm.fileName &&
                                                  _vm.fileName.length > 0
                                                    ? 10
                                                    : 12
                                                }`,
                                                md: `${
                                                  _vm.fileName &&
                                                  _vm.fileName.length > 0
                                                    ? 4
                                                    : 6
                                                }`,
                                                lg: `${
                                                  _vm.fileName &&
                                                  _vm.fileName.length > 0
                                                    ? 4
                                                    : 6
                                                }`,
                                                xl: `${
                                                  _vm.fileName &&
                                                  _vm.fileName.length > 0
                                                    ? 4
                                                    : 6
                                                }`,
                                              },
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "w-100",
                                                  attrs: { label: "" },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      type: "text",
                                                      id: "docFileName",
                                                    },
                                                    model: {
                                                      value: _vm.fileName,
                                                      callback: function ($$v) {
                                                        _vm.fileName = $$v
                                                      },
                                                      expression: "fileName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm.fileName &&
                                          _vm.fileName.length > 0
                                            ? _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "d-flex justify-content-start align-items-center",
                                                  staticStyle: {
                                                    "margin-bottom": "-16px",
                                                  },
                                                  attrs: {
                                                    sm: "2",
                                                    md: "2",
                                                    lg: "2",
                                                    xl: "2",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      class: {
                                                        "btn-transparent text-color-rhapsody-in-blue":
                                                          _vm.$screen.width >
                                                          576,
                                                        "btn btn-primary":
                                                          _vm.$screen.width <=
                                                          576,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewDocument(
                                                            _vm.confirmation
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        _vm.getLucideIcon(
                                                          "Eye"
                                                        ),
                                                        {
                                                          tag: "component",
                                                          attrs: {
                                                            size: 22,
                                                            "stroke-width": 1.5,
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                sm: "12",
                                                md: "6",
                                                lg: "6",
                                                xl: "6",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: _vm.FormMSG(
                                                      60,
                                                      "Accomodation from"
                                                    ),
                                                    "label-for": "str_date",
                                                  },
                                                },
                                                [
                                                  _c("b-form-datepicker", {
                                                    attrs: {
                                                      id: "str_date",
                                                      disabled: false,
                                                      locale: _vm.currentLang,
                                                    },
                                                    model: {
                                                      value: _vm.strDate,
                                                      callback: function ($$v) {
                                                        _vm.strDate = $$v
                                                      },
                                                      expression: "strDate",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-col",
                                            {
                                              attrs: {
                                                sm: "12",
                                                md: "6",
                                                lg: "6",
                                                xl: "6",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: _vm.FormMSG(
                                                      61,
                                                      "Until"
                                                    ),
                                                    "label-for": "str_date",
                                                  },
                                                },
                                                [
                                                  _c("b-form-datepicker", {
                                                    attrs: {
                                                      id: "end_date",
                                                      disabled: false,
                                                      locale: _vm.currentLang,
                                                    },
                                                    model: {
                                                      value: _vm.endDate,
                                                      callback: function ($$v) {
                                                        _vm.endDate = $$v
                                                      },
                                                      expression: "endDate",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-card-body",
                                    { staticClass: "p-0" },
                                    [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "card-border-blue-light",
                                          attrs: { "no-body": "" },
                                        },
                                        [
                                          _c(
                                            "b-card-body",
                                            [
                                              _c(
                                                "fieldset",
                                                {
                                                  staticClass:
                                                    "scheduler-border border-groove-blue-streak pt-0",
                                                },
                                                [
                                                  _c(
                                                    "legend",
                                                    {
                                                      staticClass:
                                                        "scheduler-border text-color-blue-streak",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.caption2)
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            sm: "12",
                                                            md: "8",
                                                            lg: "8",
                                                            xl: "8",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "b-row",
                                                            [
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    sm: "12",
                                                                    md: "8",
                                                                    lg: "8",
                                                                    xl: "8",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        "label-for":
                                                                          "deliver-to-department",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              id: "deliver-to-department",
                                                                              options:
                                                                                _vm.mapDepartments,
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              _vm.departmentChange,
                                                                          },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.selectedDepartment,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.selectedDepartment =
                                                                                    $$v
                                                                                },
                                                                              expression:
                                                                                "selectedDepartment",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    sm: "12",
                                                                    md: "4",
                                                                    lg: "4",
                                                                    xl: "4",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-button",
                                                                    {
                                                                      attrs: {
                                                                        variant:
                                                                          "success",
                                                                        disabled:
                                                                          _vm.selectedDepartment ==
                                                                          0,
                                                                        size: "md",
                                                                        block:
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.addDepToSelection()
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            this.FormMSG(
                                                                              71,
                                                                              "Add departement to selection"
                                                                            )
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "b-row",
                                                            [
                                                              _c(
                                                                "b-col",
                                                                {
                                                                  staticClass:
                                                                    "d-flex align-items-center",
                                                                  attrs: {
                                                                    sm: "2",
                                                                    md: "2",
                                                                    lg: "2",
                                                                    xl: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "check-actions cursor-pointer",
                                                                      on: {
                                                                        click:
                                                                          _vm.switchCheckAll,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm.checkAll
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "d-flex align-items-center",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "pr-2",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.FormMSG(
                                                                                        81,
                                                                                        "All"
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                _vm.getLucideIcon(
                                                                                  "CheckSquare"
                                                                                ),
                                                                                {
                                                                                  tag: "component",
                                                                                  staticClass:
                                                                                    "icon",
                                                                                  attrs:
                                                                                    {
                                                                                      size: 18,
                                                                                      "stroke-width": 2,
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "d-flex align-items-center",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "pr-2",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.FormMSG(
                                                                                        82,
                                                                                        "None"
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                _vm.getLucideIcon(
                                                                                  "Square"
                                                                                ),
                                                                                {
                                                                                  tag: "component",
                                                                                  staticClass:
                                                                                    "icon",
                                                                                  attrs:
                                                                                    {
                                                                                      size: 18,
                                                                                      "stroke-width": 2,
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm.$screen
                                                                .width >= 992
                                                                ? _c(
                                                                    "b-col",
                                                                    {
                                                                      staticClass:
                                                                        "d-flex align-items-center",
                                                                      class: `${
                                                                        _vm
                                                                          .$screen
                                                                          .width <
                                                                        992
                                                                          ? "py-3"
                                                                          : ""
                                                                      }`,
                                                                      attrs: {
                                                                        sm: "10",
                                                                        md: "10",
                                                                        lg: "10",
                                                                        xl: "10",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm
                                                                        .$screen
                                                                        .width >=
                                                                      992
                                                                        ? _c(
                                                                            "b-input-group",
                                                                            [
                                                                              _c(
                                                                                "b-form-input",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      type: "text",
                                                                                      placeholder:
                                                                                        _vm.FormMSG(
                                                                                          83,
                                                                                          "Type to Search"
                                                                                        ),
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm.filter,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.filter =
                                                                                            $$v
                                                                                        },
                                                                                      expression:
                                                                                        "filter",
                                                                                    },
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "b-input-group-append",
                                                                                {
                                                                                  staticClass:
                                                                                    "cursor-pointer",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "b-input-group-text",
                                                                                    {
                                                                                      staticClass:
                                                                                        "btn-search",
                                                                                    },
                                                                                    [
                                                                                      _vm
                                                                                        .filter
                                                                                        .length ===
                                                                                      0
                                                                                        ? _c(
                                                                                            _vm.getLucideIcon(
                                                                                              "Search"
                                                                                            ),
                                                                                            {
                                                                                              tag: "component",
                                                                                              staticClass:
                                                                                                "icon",
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    "#FFFFFF",
                                                                                                  size: 16,
                                                                                                  "stroke-width": 2.5,
                                                                                                },
                                                                                            }
                                                                                          )
                                                                                        : _c(
                                                                                            _vm.getLucideIcon(
                                                                                              "X"
                                                                                            ),
                                                                                            {
                                                                                              tag: "component",
                                                                                              staticClass:
                                                                                                "icon",
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    "#FFFFFF",
                                                                                                  size: 16,
                                                                                                  "stroke-width": 2.5,
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    _vm.filter =
                                                                                                      ""
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center",
                                                          attrs: {
                                                            sm: "12",
                                                            md: "4",
                                                            lg: "4",
                                                            xl: "4",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "b-button",
                                                            {
                                                              style: {
                                                                width: `${
                                                                  _vm.$screen
                                                                    .width >=
                                                                  992
                                                                    ? "50%"
                                                                    : "100%"
                                                                }`,
                                                              },
                                                              attrs: {
                                                                variant:
                                                                  "outline-secondary",
                                                                disabled:
                                                                  this.somethingToPublish() ==
                                                                  false,
                                                                size: "md",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.publishAccomodation()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    this.FormMSG(
                                                                      75,
                                                                      "Publish selection"
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    {
                                                      staticClass:
                                                        "hide-on-desktop",
                                                      attrs: {
                                                        cols: "12",
                                                        xl: "12",
                                                      },
                                                    },
                                                    [
                                                      _c("CardListBuilder", {
                                                        attrs: {
                                                          items: _vm.Dlvs,
                                                          fields:
                                                            _vm.delifields,
                                                          omittedFields: [
                                                            "selected",
                                                          ],
                                                        },
                                                        on: {
                                                          "row-clicked":
                                                            _vm.rowClicked,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "actions",
                                                              fn: function (
                                                                data
                                                              ) {
                                                                return [
                                                                  data.item
                                                                    .selected &&
                                                                  data.item
                                                                    .status ==
                                                                    0 &&
                                                                  data.item.startDate.substring(
                                                                    0,
                                                                    4
                                                                  ) != "2000"
                                                                    ? _c(
                                                                        "b-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              variant:
                                                                                "warning",
                                                                              size: "sm",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.unselectItem(
                                                                                  data.item
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "icon-check",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  data.item
                                                                    .selected &&
                                                                  data.item
                                                                    .status > 0
                                                                    ? _c(
                                                                        "b-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              variant:
                                                                                "warning",
                                                                              size: "sm",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.unselectItem(
                                                                                  data.item
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "icon-check",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  data.item
                                                                    .selected ==
                                                                  false
                                                                    ? _c(
                                                                        "b-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              variant:
                                                                                "outline-primary",
                                                                              size: "sm",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.selectItem(
                                                                                  data.item
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "icon-check",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  data.item
                                                                    .fileName &&
                                                                  data.item
                                                                    .fileName
                                                                    .length > 0
                                                                    ? _c(
                                                                        "b-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              variant:
                                                                                "primary",
                                                                              size: "sm",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.viewDocument(
                                                                                  data
                                                                                    .item
                                                                                    .confirmation
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "icon-eye",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          false,
                                                          900400743
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      staticClass:
                                                        "hide-on-tablet",
                                                      attrs: {
                                                        cols: "12",
                                                        xl: "12",
                                                      },
                                                    },
                                                    [
                                                      _c("b-table", {
                                                        ref: "myTable",
                                                        staticStyle: {
                                                          "text-align": "left",
                                                        },
                                                        attrs: {
                                                          hover: _vm.hover,
                                                          responsive: "sm",
                                                          selectable: "",
                                                          "sticky-header":
                                                            "700px",
                                                          selectedVariant:
                                                            _vm.selectedColor,
                                                          "select-mode":
                                                            _vm.selectMode,
                                                          items: _vm.Dlvs,
                                                          fields:
                                                            _vm.delifields,
                                                          "current-page":
                                                            _vm.currentPage,
                                                          filter: _vm.filter,
                                                          "per-page":
                                                            _vm.perPage,
                                                          "head-variant":
                                                            _vm.hv,
                                                          bordered: "",
                                                          small: "",
                                                        },
                                                        on: {
                                                          "row-clicked":
                                                            _vm.rowClicked,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "cell(selected)",
                                                              fn: function (
                                                                data
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "cursor-pointer py-0",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-checkbox",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              size: "lg",
                                                                              disabled:
                                                                                data
                                                                                  .item
                                                                                  .status ===
                                                                                4,
                                                                            },
                                                                          on: {
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.selectAccomodation(
                                                                                  data,
                                                                                  $event
                                                                                )
                                                                              },
                                                                          },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                data
                                                                                  .item
                                                                                  .selected,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    data.item,
                                                                                    "selected",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "data.item.selected",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                            {
                                                              key: "cell(status)",
                                                              fn: function (
                                                                data
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "wrap-status",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          class: `status ${data.item.validatedClass}`,
                                                                          staticStyle:
                                                                            {
                                                                              "font-size":
                                                                                "0.7rem",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                data.value
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                            {
                                                              key: "cell(view)",
                                                              fn: function (
                                                                data
                                                              ) {
                                                                return [
                                                                  data.item
                                                                    .fileName &&
                                                                  data.item
                                                                    .fileName
                                                                    .length > 0
                                                                    ? _c(
                                                                        "b-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              variant:
                                                                                "primary",
                                                                              size: "sm",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.viewDocument(
                                                                                  data
                                                                                    .item
                                                                                    .confirmation
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "icon-eye",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          false,
                                                          2886969055
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          staticClass: "modal-success",
          attrs: {
            "header-class": "header-class-modal-doc-package",
            title: this.FormMSG(104, "Success!"),
            "ok-variant": "success",
            "ok-only": "",
          },
          on: {
            ok: function ($event) {
              _vm.successModal = false
            },
          },
          model: {
            value: _vm.successModal,
            callback: function ($$v) {
              _vm.successModal = $$v
            },
            expression: "successModal",
          },
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.FormMSG(80, "The new document has been saved.")) +
              "\n\t"
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          staticClass: "modal-success",
          attrs: {
            "header-class": "header-class-modal-doc-package",
            title: this.FormMSG(104, "Success!"),
            "ok-variant": "success",
            "ok-only": "",
          },
          on: {
            ok: function ($event) {
              _vm.successModalDelete = false
            },
          },
          model: {
            value: _vm.successModalDelete,
            callback: function ($$v) {
              _vm.successModalDelete = $$v
            },
            expression: "successModalDelete",
          },
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.FormMSG(103, "Your document has been deleted.")) +
              "\n\t"
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }